import { RegexFilter } from "../../../param/generalSearchFilter";
import { ListDefinition } from "../../../param/listDefinitionType";
import { filter } from "../commonLoop";
import { createRegex } from "../exRegexp";
import { Result } from "../generalSearchResult";

export const regexFilter = async ({
  query,
  listDefinitionsTable,
  result,
  workerContext,
}: {
  query: RegexFilter;
  listDefinitionsTable: Record<string, ListDefinition>;
  result: Result;
  workerContext: any;
}) => {
  const reg = createRegex(query.pattern, listDefinitionsTable);
  return filter(workerContext, result, (e) => {
    return (
      (query.notMatch && !e.currentWord.match(reg)) ||
      (!query.notMatch && !!e.currentWord.match(reg))
    );
  });
};
